import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';

function* getVideos() {
  try {
    const { data, status } = yield call(api.videos.getVideos);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_VIDEOS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_VIDEOS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createVideo({ payload }) {
  try {
    const { data, status } = yield call(api.videos.createVideo, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.CREATE_VIDEOS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.CREATE_VIDEOS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateVideo({ payload }) {
  try {
    const { status } = yield call(api.videos.updateVideo, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_VIDEOS_SUCCESS });
    yield put({ type: types.GET_VIDEOS_START });
  } catch (error) {
    yield put({ type: types.UPDATE_VIDEOS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deleteVideo({ payload }) {
  try {
    const { status } = yield call(api.videos.deleteVideo, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_VIDEOS_SUCCESS, payload: payload.id });
  } catch (error) {
    yield put({ type: types.DELETE_VIDEOS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* videos() {
  yield all([
    takeLatest(types.GET_VIDEOS_START, getVideos),
    takeLatest(types.CREATE_VIDEOS_START, createVideo),
    takeLatest(types.UPDATE_VIDEOS_START, updateVideo),
    takeLatest(types.DELETE_VIDEOS_START, deleteVideo),
  ]);
}
